import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/admin/login', { replace: true });
        return;
      }

      try {
        // Exchange session_id for session_token
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          const error = await response.json();
          console.error('Auth error:', error);
          navigate('/admin/login', { 
            replace: true,
            state: { error: error.detail || 'Authentication failed' }
          });
          return;
        }

        const userData = await response.json();
        
        // Redirect to admin dashboard with user data
        navigate('/admin', { 
          replace: true,
          state: { user: userData }
        });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/admin/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-yellow-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
